var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "briefcase-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg briefcase",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "briefcase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4,10.2a1.54,1.54,0,0,0-1.5,1.5V26.2a1.54,1.54,0,0,0,1.5,1.5H27.6a1.54,1.54,0,0,0,1.5-1.5V11.6a1.54,1.54,0,0,0-1.5-1.5H4.4ZM0,11.6A4.44,4.44,0,0,1,4.4,7.2H27.6A4.44,4.44,0,0,1,32,11.6V26.1a4.44,4.44,0,0,1-4.4,4.4H4.4A4.44,4.44,0,0,1,0,26.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,2.8a4.39,4.39,0,0,1,3.1-1.3h5.8a4.44,4.44,0,0,1,4.4,4.4V29.1a1.5,1.5,0,0,1-3,0V5.8a1.53,1.53,0,0,0-.4-1,1.28,1.28,0,0,0-1-.4H13.1a1.53,1.53,0,0,0-1,.4,1.28,1.28,0,0,0-.4,1V29a1.5,1.5,0,0,1-3,0V5.8A4.34,4.34,0,0,1,10,2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.8d31b9cc685e3f9d240565c1bc412ec3.svg";
export { ForwardRef as ReactComponent };